import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Somebody finally figured out how to do marketing on Twitter!",
  "description": "",
  "published": "2011-07-25T00:00:00.000Z",
  "redirect_from": ["/blog/somebody-finally-figured-out-how-to-do-marketing-on-twitter/swizec/1995"],
  "categories": "Marketing, Old Spice, Twitter, Uncategorized, YouTube",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/07/5883431001_8af6e98dc3_m.jpg",
        "alt": "Old Spice Guy in a Towel",
        "title": "Old Spice Guy in a Towel"
      }}></img></p>
    <p>{`Everyone can probably agree that marketing on twitter is quite prolific to say the least. That there are a bunch of people marketing. That there are almost more brands using it as there are people. Many people have a personal account and two, three, four brand accounts ... you know, because that one side project you did that weekend when you kind of had two beers too many and were hopped up on energy drinks ... yeah, that totally needs its own twitter account.`}</p>
    <p>{`Needless to say, Twitter is becoming increasingly annoying.`}</p>
    <p>{`Mostly because of clueless marketers.`}</p>
    <p><em parentName="p">{`tl;dr --> Nobody cares about your stupid product, we care about you. Even a fake you.`}</em></p>
    <p>{`It's actually an awesome platform and I feel I've made many a meaningful connection on it.`}</p>
    <p>{`But the marketers! Dear fuck, the marketers!`}</p>
    <p>{`Then `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Old_Spice",
        "title": "Old Spice"
      }}>{`Old Spice`}</a>{` came along and changed everything. I'm not sure when exactly this happened, but I noticed it a couple of hours ago. Apparently there are now two Old Spice Guys competing for the coveted spot of being THE Old Spice Guy.`}</p>
    <p>{`Just to refresh your memory, this is the real Old Spice Guy. I call him the real one because he's awesome (see, it's already working)`}</p>
    <lite-youtube {...{
      "videoid": "owGykVbfgUE",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`The new guy is Fabio. He is very lame and I quite suspect this is on purpose. It's very difficult to look this fake if you're not doing it on purpose ... especially with that kind of marketing budget.`}</p>
    <lite-youtube {...{
      "videoid": "ie8yn2J08Qc",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Lame. Craptastic even. Almost as bad as Rebecca Black ... worse?`}</p>
    <p>{`And then the fun part comes in. Both of these guys have their own twitter accounts. @`}<a parentName="p" {...{
        "href": "http://twitter.com/oldspice",
        "title": "@OldSpice"
      }}>{`OldSpice`}</a>{` and @`}<a parentName="p" {...{
        "href": "http://twitter.com/fabiooldspices"
      }}>{`FabioOldSpices`}</a>{` respectively. They are poking fun at each other. The original guy is all manly and awesome. He could climb the highest mountain and punch the face of god, that kind of awesome. And Fabio is the paragon of being a fancy `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Sissy",
        "title": "Sissy"
      }}>{`sissy boy`}</a>{`.`}</p>
    <p>{`Do I even have to explain more?`}</p>
    <p>{`Rather than being pushy and all markety, Old Spice has created two competing personas and they are making us root for our favourite. Watch the fight and just generally have fun with them. They have honestly made me want to follow both of those accounts and just see what happens.`}</p>
    <p>{`Like watching a well thought out play.`}</p>
    <p>{`And that right there is brilliant, tell a story, have fun, that's what twitter is about. Nobody cares about your stupid product, we care about `}<em parentName="p">{`you`}</em>{`. Even a fake you.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://mashable.com/2011/07/25/fabio-mustafa-old-spice-challenge/"
        }}>{`EXCLUSIVE: Fabio Issues "Challenge" to Old Old Spice Guy Isaiah Mustafa `}{`[`}{`VIDEO`}{`]`}</a>{` (mashable.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.adweek.com/adfreak/meet-your-newest-old-spice-guy-fabio-yes-fabio-133565"
        }}>{`Meet Your Newest Old Spice Guy: Fabio (Yes, That Fabio)`}</a>{` (adweek.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.adpulp.com/new-chapter-for-fabio-and-old-spice/"
        }}>{`New Chapter For Fabio And Old Spice`}</a>{` (adpulp.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=579041c8-8fc7-40f1-a471-5b59f200392f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      